import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import CommonCard from '../card/CommonCard';
import { ContentsIconDefault } from '../../assets/images/contentsIconDefault';

export const ActivityCard = ({
    icon,
    title,
    time,
    score,
    didimValue,
    calorieValue,
    timeValue
}) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <CommonCard>
            <Box sx={{
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                width: '100%'
            }}>
                {/* 아이콘 */}
                {icon ? (
                    <Box sx={{
                        width: '60px',
                        height: '60px',
                        borderRadius: '30px',
                        backgroundColor: theme.palette.figma.white[10],
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: `3px solid ${theme.palette.figma.white[30]}`,
                        flexShrink: 0
                    }}>
                        <img
                            src={icon}
                            alt={title}
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                borderRadius: '30px'
                            }}
                        />
                    </Box>
                ) : (
                    <ContentsIconDefault />
                )}

                {/* 정보 */}
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '5px',
                    flex: 1
                }}>
                    <Typography sx={{
                        color: theme.palette.figma.white[80],
                        fontSize: '16px',
                        fontWeight: 500,
                        letterSpacing: '-0.48px',
                        textAlign: 'left'
                    }}>
                        {title}
                    </Typography>
                    <Box sx={{
                        display: 'flex',
                        gap: '10px',
                        alignItems: 'center'
                    }}>
                        <Typography sx={{
                            color: theme.palette.figma.white[60],
                            fontSize: '12px',
                            fontWeight: 400,
                            letterSpacing: '-0.36px'
                        }}>
                            {time}
                        </Typography>
                        {score && (
                            <Typography sx={{
                                color: theme.palette.figma.didim,
                                fontSize: '12px',
                                fontWeight: 500,
                                letterSpacing: '-0.36px'
                            }}>
                                {score}
                            </Typography>
                        )}
                    </Box>
                </Box>

                {/* 통계 */}
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '5px',
                    alignItems: 'flex-end'
                }}>
                    <Box sx={{
                        display: 'flex',
                        gap: '5px',
                        alignItems: 'center'
                    }}>
                        <Typography sx={{
                            color: theme.palette.figma.didim,
                            fontSize: '14px',
                            fontWeight: 600,
                            letterSpacing: '-0.42px'
                        }}>
                            {didimValue}
                        </Typography>
                        <Typography sx={{
                            color: theme.palette.figma.white[60],
                            fontSize: '12px',
                            fontWeight: 400,
                            letterSpacing: '-0.36px'
                        }}>
                            {t('didim')}
                        </Typography>
                    </Box>
                    <Box sx={{
                        display: 'flex',
                        gap: '5px',
                        alignItems: 'center'
                    }}>
                        <Typography sx={{
                            color: theme.palette.figma.calorieRed,
                            fontSize: '14px',
                            fontWeight: 600,
                            letterSpacing: '-0.42px'
                        }}>
                            {calorieValue}
                        </Typography>
                        <Typography sx={{
                            color: theme.palette.figma.white[60],
                            fontSize: '12px',
                            fontWeight: 400,
                            letterSpacing: '-0.36px'
                        }}>
                            kcal
                        </Typography>
                    </Box>
                    <Typography sx={{
                        color: theme.palette.figma.time,
                        fontSize: '14px',
                        fontWeight: 600,
                        letterSpacing: '-0.42px'
                    }}>
                        {timeValue}
                    </Typography>
                </Box>
            </Box>
        </CommonCard>
    );
};

export default ActivityCard;

